var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRhtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.79 50.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 6.67c8.4 1.59 14.57.6 18.22-1.58 1.74-1 5.6-3.7 7.13-3.7a40.91 40.91 0 0 0 8.9-1.32c1.93-.72 6.56 4.63 7.24 5.71a3.59 3.59 0 0 0 2.5 1.2s.86-3.24.57-4 3.65 0 3.74 1.68-1.24 4-1 5.16.13 4.79.81 6 1.44 2.18 2.54 1.69c2-.88 4.07-7 4.07-7s1.64 6-1 10.25c1.72.72 6.13-2.65 8.34-9.6 0 0 1.3 11.18-4.6 15.12a5.11 5.11 0 0 0-2.4 5.87s-1.81 2.65-3.81 2.17a18.17 18.17 0 0 1-7-3.72c-1.35-1.43-3.08-4.19-3.46-4a25.67 25.67 0 0 0-3.74 3.36c-.58.84-2 1-2.4 1.91s-.86 3.61-1.83 4.45a5.18 5.18 0 0 0-1.63 3.35c0 1 .31 5.17 1.27 6a24.74 24.74 0 0 1 1.79 2.35 4 4 0 0 1 .54 2.22h-6.05v-3.13s-3.88-6.31-3.49-7.15-.1-4-1.25-4-7.39 3-10.27 2.16a75.66 75.66 0 0 1-9.12-4.08 15.18 15.18 0 0 0-1.44 5c0 2.05 2.91 4.6 3.49 5.57s1.73 2.7 2.3 2.83 1.2 2.72 1.2 2.72h-7.43l.91-1.88L9.93 34.4a18.2 18.2 0 0 0-.56 7.92c.4 2.18 2.82 5.35 3.09 5.65a3.12 3.12 0 0 1 .47 2.27h-6a45 45 0 0 1-2.12-6.35c-.19-1.56 1.87-7.06.71-8.85S2.27 24.97 2.83 22.33c-1 2.76-.89 10.87.07 19.86s-6.92-18-.07-27.06c5.19-6.83 8.85-8.84 10.85-8.46z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhtr);
export default __webpack_public_path__ + "static/media/RHTR.794a4542a9cd55103402bc8588180e9d.svg";
export { ForwardRef as ReactComponent };